import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import menuData from './FooterMenuData.jsx'
import FooterTop from './FooterTop.jsx';
const FooterMenu = () => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
    const currentYear = new Date().getFullYear();
    return (
        <Container>

            <Row className="mb-5">
                <FooterTop />
            </Row>
            <Row>
                {menuData.map((menu, index) => (
                    <Col className="col-12 col-lg-3 col-md-6 my-3 my-lg-0" key={index}>
                        <h5 className="gray h5">{menu.title}</h5>
                        <ul className="pt-4 mb-0 ps-0 footer--links">
                            {menu.links.map((link, linkIndex) => (
                                <li className="nav-item " key={linkIndex}>
                                    <Link onClick={scrollToTop} to={link.url} className="gray">{link.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </Col>
                ))}

            </Row>
            <Row>
                <div className="d-flex justify-content-center py-4 mt-4 border-top border-gray">
                    <p className='mb-0 gray'>
                        &copy; Copyright {currentYear} Europcar | All rights reserved. | © Powered By Yiron Technologies.
                    </p>
                </div>
            </Row>
        </Container>
    )
}

export default FooterMenu;